import React from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';

const TermsAndConditions = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Header />

      <Container id="terms" maxWidth="md" style={{ marginTop: "20px", marginBottom: "20px" }}>
        <Typography variant="h4" style={{   color: "#00704A", borderBottom: "2px solid #EEE", paddingBottom: 1}} gutterBottom>
          {t("terms_title")}
        </Typography>
            <Typography variant="body1" paragraph>
                <strong> {t("effective_date")} </strong> 4th December 2025
              </Typography>
           
        <Card>
          <CardContent>
            <Box mb={3}>
              <Typography variant="body1" paragraph>
                 {t("terms_para_1")}
              </Typography>
                                <Typography variant="body1" paragraph>
                 {t("terms_para_2")}
              </Typography>
              <Typography variant="body1" paragraph>
                 {t("terms_para_3")}
              </Typography>
                                <Typography variant="body1" paragraph>
                 {t("terms_para_4")}
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>A.</strong> {t("terms_section_a")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>B.</strong> {t("terms_section_b")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>C.</strong> {t("terms_section_c")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>D.</strong> {t("terms_section_d")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>E.</strong> {t("terms_section_e")}
              </Typography>

              <Typography variant="h6" gutterBottom>
                {t("terms_general_title")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>I.</strong> {t("terms_i")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>II.</strong> {t("terms_ii")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>III.</strong> {t("terms_iii")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>IV.</strong> {t("terms_iv")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>V.</strong> {t("terms_v")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>VI.</strong> {t("terms_vi")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>VII.</strong> {t("terms_vii")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>VIII.</strong> {t("terms_viii")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>IX.</strong> {t("terms_ix")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>X.</strong> {t("terms_x")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>XI.</strong> {t("terms_xi")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>XII.</strong> {t("terms_xii")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>XIII.</strong> {t("terms_xiii")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>XIV.</strong> {t("terms_xiv")}
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>XV.</strong> {t("terms_xv")}
              </Typography>
                 
                               <Typography variant="h6" gutterBottom>
               <strong>1.</strong> {t("terms_general_consumer")}
              </Typography>

              <Typography variant="body1" paragraph>
                 {t("terms_general_consumer_para1")} 
              </Typography>

 <Typography variant="h6" gutterBottom>
               <strong>2.</strong> {t("terms_integrity")}
              </Typography>

              <Typography variant="body1" paragraph>
                 {t("terms_integrity_para1")} 
              </Typography>
                  
              <Typography variant="body1" paragraph>
                 {t("terms_integrity_para2")} 
              </Typography>

 <Typography variant="h6" gutterBottom>
               <strong>3.</strong> {t("terms_order")}
              </Typography>

              <Typography variant="body1" paragraph>
                 {t("terms_order_para1")} 
              </Typography>
                  
              <Typography variant="body1" paragraph>
                 {t("terms_order_para2")} 
              </Typography>

                  
              <Typography variant="body1" paragraph>
                 {t("terms_order_para3")} 
              </Typography>
                  
                  
                  
                  
                  <Typography variant="h7" gutterBottom>
               <strong>3.1. </strong> {t("terms_order_timing")}
              </Typography>

              <Typography variant="body1" paragraph>
                 {t("terms_order_timing_p1")} 
              </Typography>


              <Typography variant="body1" paragraph>
                 {t("terms_order_timing_p2")} 
              </Typography>
                  
                                <Typography variant="body1" paragraph>
                 {t("terms_order_timing_p3")} 
              </Typography>

                <Typography variant="h7" gutterBottom>
               <strong>3.2. </strong> {t("terms_order_timing_2")}
              </Typography>

              <Typography variant="body1" paragraph>
                 {t("terms_order_timing_2_p1")} 
              </Typography>
                                  <Typography variant="h7" gutterBottom>
               <strong>3.3. </strong> {t("terms_order_timing_3")}
              </Typography>

              <Typography variant="body1" paragraph>
                 {t("terms_order_timing_3_p1")} 
              </Typography>

 <Typography variant="h6" gutterBottom>
               <strong>4.</strong> {t("terms_price")}
              </Typography>
                  
                  
              <Typography variant="body1" paragraph>
                 {t("terms_price_para1")} 
              </Typography>
                  
              <Typography variant="body1" paragraph>
                 {t("terms_price_para2")} 
              </Typography>
                  
                  


 <Typography variant="h6" gutterBottom>
               <strong>5.</strong> {t("terms_payment")}
              </Typography>
                              <Typography variant="body1" paragraph>
                 {t("terms_payment_para1")} 
              </Typography>
                  
 <Typography variant="h6" gutterBottom>
               <strong>6.</strong> {t("terms_special")}
              </Typography>
 <Typography variant="body1" paragraph>
                 {t("terms_special_para1")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>7.</strong> {t("terms_delivery")}
              </Typography>
                   <Typography variant="body1" paragraph>
                 {t("terms_delivery_para1")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>8.</strong> {t("terms_limit")}
              </Typography>

   <Typography variant="body1" paragraph>
                 {t("terms_limit_para1")} 
              </Typography>

                     <Typography variant="body1" paragraph>
                 {t("terms_limit_para2")} 
              </Typography>
   <Typography variant="body1" paragraph>
                 {t("terms_limit_para3")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>9.</strong> {t("terms_restrictions")}
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_restrictions_para1")} 
              </Typography>

 <Typography variant="h6" gutterBottom>
               <strong>10.</strong> {t("terms_privacy")}
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_privacy_para1")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>11.</strong> {t("terms_review")}
              </Typography>
                    <Typography variant="body1" paragraph>
                 {t("terms_review_para1")} 
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_review_para2")} 
              </Typography>
                    <Typography variant="body1" paragraph>
                 {t("terms_review_para3")} 
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_review_para4")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>12.</strong> {t("terms_responsibility")}
              </Typography>
                  
                  <Typography variant="body1" paragraph>
                 {t("terms_responsibility_para1")} 
              </Typography>
   <Typography variant="body1" paragraph>
                 {t("terms_responsibility_para2")} 
              </Typography>

 <Typography variant="h6" gutterBottom>
               <strong>13.</strong> {t("terms_intellectual")}
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_intellectual_para1")} 
              </Typography>
                    <Typography variant="body1" paragraph>
                 {t("terms_intellectual_para2")} 
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_intellectual_para3")} 
              </Typography>
                    <Typography variant="body1" paragraph>
                 {t("terms_intellectual_para4")} 
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_intellectual_para5")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>14.</strong> {t("terms_technical")}
              </Typography>
                   <Typography variant="body1" paragraph>
                 {t("terms_technical_para1")} 
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_technical_para2")} 
              </Typography>
                    <Typography variant="body1" paragraph>
                 {t("terms_technical_para3")} 
              </Typography>
  <Typography variant="body1" paragraph>
                 {t("terms_technical_para4")} 
              </Typography>
                    <Typography variant="body1" paragraph>
                 {t("terms_technical_para5")} 
              </Typography>
 <Typography variant="h6" gutterBottom>
               <strong>15.</strong> {t("terms_digital")}
              </Typography>
 <Typography variant="body1" paragraph>
                 {t("terms_digital_para1")} 
              </Typography>
 {t("terms_updateddate_para1")}
                  
            </Box>
          </CardContent>
        </Card>
      </Container>

      <Footer />
    </>
  );
};

export default TermsAndConditions;
